import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const CloudCross = forwardRef(function CloudCross(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 11a6.25 6.25 0 0 1 12.322-1.488.75.75 0 0 0 .458.522A4.252 4.252 0 0 1 17 18.25H6a3.25 3.25 0 0 1-.812-6.398.75.75 0 0 0 .563-.74V11ZM12 3.25a7.75 7.75 0 0 0-7.739 7.329 4.751 4.751 0 0 0 1.74 9.171h11a5.75 5.75 0 0 0 2.428-10.963A7.753 7.753 0 0 0 12 3.25Zm-1.47 7.22a.75.75 0 0 0-1.06 1.06L10.94 13l-1.47 1.47a.75.75 0 1 0 1.06 1.06L12 14.06l1.47 1.47a.75.75 0 0 0 1.06-1.06L13.06 13l1.47-1.47a.75.75 0 1 0-1.06-1.06L12 11.94l-1.47-1.47Z"
        fill="currentColor"
      />
    </Icon>
  );
});
